import { IClientComponentDefinition } from '@glidecms/deliver-core-dev/gd-module'

export const VerticalHeaderCCD: IClientComponentDefinition = {
  name: 'verticalHeader',
  load: () => import(/* webpackChunkName: 'verticalHeader' */ './w-vertical-header'),
}
